import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { supabase } from '@/lib/supabase';
const NAV_ITEMS = [
    { label: 'Dashboard', to: '/admin' },
    { label: 'Calendar', to: '/admin/calendar' },
    { label: 'Daily Register', to: '/admin/daily-register' },
    { label: 'Bookings', to: '/admin/open-bookings' },
    { label: 'New Booking', to: '/admin/bookings/new' },
    { label: 'Customers', to: '/admin/customers' },
    { label: 'Bulk Invite', to: '/admin/bulk-invite' },
    { label: 'Services', to: '/admin/services' },
    { label: 'Marketing', to: '/admin/marketing' },
    { label: 'Users', to: '/admin/users' },
    { label: 'Settings', to: '/admin/settings' },
];
const MOBILE_NAV = [
    { label: 'Dash', to: '/admin', icon: '⊞' },
    { label: 'Calendar', to: '/admin/calendar', icon: '▦' },
    { label: 'Book', to: '/admin/bookings/new', icon: '+' },
    { label: 'Customers', to: '/admin/customers', icon: '○' },
    { label: 'Market', to: '/admin/marketing', icon: '✦' },
    { label: 'Settings', to: '/admin/settings', icon: '⚙' },
];
export default function AdminLayout({ children }) {
    const { pathname } = useLocation();
    const navigate = useNavigate();
    function isActive(to) {
        if (to === '/admin')
            return pathname === '/admin';
        return pathname.startsWith(to);
    }
    async function handleLogout() {
        await supabase.auth.signOut();
        navigate('/');
    }
    return (_jsxs("div", { className: "min-h-screen flex bg-white", children: [_jsxs("aside", { className: "hidden md:flex md:flex-col md:w-64 text-white shrink-0 fixed inset-y-0 left-0 z-30", style: { backgroundColor: '#444444' }, children: [_jsxs("div", { className: "px-4 pt-4 pb-2", children: [_jsx("img", { src: "/images/logo-v3.webp", alt: "Springfield Dog Centre", className: "w-full rounded-lg" }), _jsx("p", { className: "text-[10px] text-gray-400 uppercase tracking-widest text-center mt-2", children: "Admin Portal" })] }), _jsx("nav", { className: "flex-1 px-2 space-y-0.5", children: NAV_ITEMS.map(({ label, to }) => (_jsx(Link, { to: to, className: `flex items-center px-4 py-2.5 rounded-lg text-sm transition-colors ${isActive(to)
                                ? 'bg-brand-green/20 text-white font-semibold'
                                : 'text-gray-200 hover:text-white hover:bg-white/10'}`, children: label }, to))) }), _jsxs("div", { className: "px-5 py-4 border-t border-white/10", children: [_jsx("p", { className: "text-xs text-gray-400 mb-1", children: "Admin" }), _jsx("button", { onClick: handleLogout, className: "text-xs text-gray-600 hover:text-gray-300 transition-colors", children: "Sign out" })] })] }), _jsx("div", { className: "flex-1 md:ml-64 min-w-0 pb-16 md:pb-0", children: children }), _jsx("nav", { className: "md:hidden fixed bottom-0 inset-x-0 bg-white border-t border-gray-200 z-40 flex", children: MOBILE_NAV.map(({ label, to, icon }) => (_jsxs(Link, { to: to, className: `flex-1 flex flex-col items-center py-2 text-[9px] font-medium transition-colors ${isActive(to) ? 'text-brand-green' : 'text-gray-400'}`, children: [_jsx("span", { className: "text-base mb-0.5 leading-none", children: icon }), _jsx("span", { children: label })] }, to))) })] }));
}
